module.exports = __webpack_public_path__ + "img/visa.5bfbdf6c.png";